import Common from './Common'
import Manage from './Manage'
import Create from './Create'

export default {
  Common,
  Manage,
  Create
}